<template>
  <div class="container">
    <div class="login-bg">
      <div v-if="isLoading" class="spinner text-center">
        <img class="img-loading" src="~@/assets/images/spinner-loading.gif" />
      </div>
      <div v-if="error" class="w-content">
        <div class="w-logo-cnt">
          <img alt="Logo image" class="login-logo" src="~[envbyven]/assets/images/logo.png" />
        </div>
        <div class="text-danger text-center">
          <h4>
            <i class="fas fa-exclamation-triangle" />
            {{ message }}
          </h4>
        </div>
        <div class="text-center">
          <a href="/login" class="btn w-btn-secondary">{{ $t("misc.back_to") }} Login</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ExternalLoginApi from "@/api/externalLoginApi";

export default {
  data() {
    return {
      accessToken: null,
      refreshToken: null,
      isLoading: true,
      error: false
    };
  },
  created() {
    this.isLoading = true;
    this.error = false;
    this.message = "Oops ... ";
  },
  async mounted() {
    await this.init(
      this.$route.query.jwt,
      this.$route.query.refresh_token,
      this.$route.query.redirect_uri
    );
  },
  methods: {
    showError(message) {
      this.error = true;
      this.isLoading = false;
      this.message = message;
    },
    async init(externalAccessToken, externalRefreshToken, redirectUri) {
      // sanity check
      if (!externalAccessToken) {
        this.showError(this.$t("errors.missing_jwt_query_params"));
        return;
      }

      if (!externalRefreshToken) {
        this.showError(this.$t("errors.missing_refresh_token_query_params"));
        return;
      }

      const externalLoginApi = new ExternalLoginApi();

      try {
        const data = await externalLoginApi.loginToMaestroConnectApi(
          externalAccessToken,
          externalRefreshToken
        );

        data.user.loginMethod = "SCM Group login";

        await this.$store.dispatch("User/initUser", data.user);

        if (redirectUri) {
          location.href = redirectUri;
        } else {
          // Go to machine page
          await this.$router.push({
            name: "machine_map_overview"
          });
        }
      } catch (e) {
        console.error(e);
        this.showError("Oops ... " + this.$t("errors.sso_login_failed"));
      }
    }
  }
};
</script>

<style scoped lang="scss">
.img-loading {
  width: 64px;
  position: relative;
  z-index: 2;
}
.spinner {
  margin-top: 80px;
}
.w-logo-cnt > img {
  max-width: 250px;
}
.w-content {
  position: relative;
  z-index: 2;
  border: 1px solid #979797;
  border-radius: 4px 4px 5px 5px;
  background-color: #fff;
  padding: 15px;
  max-width: 500px;
  margin: 100px auto;
}
.w-content > div {
  margin-bottom: 20px;
}
.w-content .text-danger {
  padding-top: 20px;
  padding-bottom: 20px;
}
.login-bg {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: url("~@/assets/images/blur_background.jpg");
  background-size: cover;
  z-index: 1;
}
</style>
